import React, { useState, useEffect, useRef } from "react";
import { useTheme, styled } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from "prop-types";
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel,
  RadioGroup,
  MenuItem,
  Paper,
  CardHeader,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { useTranslation } from "react-i18next";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          className="float-end"
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const ProtocolItemModal = ({ handleClose, open, addProduct, ...props }) => {

  const { t, i18n } = useTranslation();
  //get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "protocol";

  const tblRefHolder = useRef({ table: null });
  const tblRef = tblRefHolder.current;
  const { isLoading, error, isError, data, refetch } = useQuery(["products"],
    api.getPrescriptionItemListModal,{
      refetchOnWindowFocus: false,
      // enabled: false // turned off by default, manual refetch is needed
    }
  );
  const [selectedProducts, setselectedProducts] = useState([]);

  const ProductColumns = [
    { title: "id", field: "ItemNo", visible: false },
    { title: "ItemNo", field: "ItemNo", visible: false },
    { title: t(DispensingLanguage[lan][menukey]['Sl#']),  formatter: "rownum", width:85, hozAlign: "center" , headerHozAlign:"center", headerSort:false},
    { title: t(DispensingLanguage[lan][menukey]['Product Name']), field: "ItemShortName", headerFilter:true  },
    { title: t(DispensingLanguage[lan][menukey]['UoM']), field: "UnitName", headerFilter:true, width:130},
    
  ];

  let selected = [];
  const ProdustDataItems = data?.map((item, index) => { 
    return item;
  });

  const [btnDisable, setbtnDisable] = useState(false);
  const SaveSelectedProducts = () => {
    if(tblRef.table.getSelectedData().length>0)
    setbtnDisable(true);
    setselectedProducts(tblRef.table.getSelectedData());
    setTimeout(() => setbtnDisable(false), 500);
    
  };

  useEffect(() => {
    addProduct(selectedProducts);

}, [selectedProducts]);
  return (
    <div>
      <BootstrapDialog
        onClose={() => handleClose('Products')}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="md"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => handleClose('Products')}
        >
        {t(DispensingLanguage[lan][menukey]['Product Description'])} 
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <ReactTabulator
            onRef={(r) => { tblRef.table = r.current; }}
            options={{
              selectableRowsRangeMode: 'click',
              selectableRows: true,
             }}
            columns={ProductColumns}
            data={ProdustDataItems}
            height="300px"
            layout={"fitColumns"}

          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={btnDisable}
            className="me-2 float-start"
            variant="contained"
            color="primary"
            onClick={SaveSelectedProducts}
          >
           {t(DispensingLanguage[lan][menukey]['ADD'])}  
          </Button>
          <Button
            autoFocus
            className="float-start"
            variant="contained"
            color="gray"
            onClick={() => handleClose('Products')}
          >
            {t(DispensingLanguage[lan][menukey]['CANCEL'])}   
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default ProtocolItemModal;
